module.exports = __webpack_public_path__ + "static/media/Melall.ba4d11c2.svg";